<div *ngIf="icon" [class]="getStyleClass()">
  <!--  Alignment will break if u change the width and height of SVG-->
  <!--  Using 1em for W/H Achieves the size change with font-size property-->
  <svg viewBox="0 0 18 18" [class]="getIconClass()">
    <use [attr.xlink:href]="getIconId()"></use>
  </svg>
</div>
